export function OrganizationLoadingSkeleton() {
  return (
    <div className="flex-1 overflow-y-auto bg-(--bg-canvas) px-6 pt-[18px] pb-[100px]">
      <div className="animate-pulse">
        <div className="flex items-start justify-between gap-8 p-6 mb-4 rounded-[10px] border border-(--border-default) bg-(--bg-white)">
          <div className="space-y-2 flex-1">
            <div className="h-5 bg-(--bg-canvas) rounded w-44" />
            <div className="h-3 bg-(--bg-canvas) rounded w-72" />
            <div className="h-3 bg-(--bg-canvas) rounded w-56" />
          </div>
          <div className="w-[120px] h-[120px] rounded-full bg-(--bg-canvas) shrink-0" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="h-[68px] rounded-[8px] border border-(--border-default) bg-(--bg-white)"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
